import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { DIMAIS_LETTER_LABELS } from '../../core/models/patient.model';
import { PatientStateService } from '../../core/services/patient-state.service';
import { PatientRegistrationDialogComponent } from '../patient-registration-dialog/patient-registration-dialog.component';

@Component({
  selector: 'app-patient-header',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatDialogModule, MatIconModule, MatSelectModule],
  templateUrl: './patient-header.component.html',
  styleUrl: './patient-header.component.scss'
})
export class PatientHeaderComponent {
  readonly patients = inject(PatientStateService);
  private readonly dialog = inject(MatDialog);

  readonly letterLabels = DIMAIS_LETTER_LABELS;

  onPatientChange(id: string): void {
    this.patients.selectPatient(id);
  }

  openRegistration(): void {
    this.dialog.open(PatientRegistrationDialogComponent, { autoFocus: false });
  }
}
